import React, { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import classNames from "classnames";
import themeConfig from "../../config/theme.config";

const QuillTextEditor = ({
    value,
    handleChange,
    placeholder = "Enter text...",
    className,
    id,
    borderWidth = themeConfig.borderWidth,
    rounded = themeConfig.rounded,
    ...rest
}) => {
    const modules = useMemo(
        () => ({
            toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [
                    { list: "ordered" },
                    { list: "bullet" },
                    { indent: "-1" },
                    { indent: "+1" },
                ],
                ["link", "image"],
                ["clean"],
            ],
        }),
        []
    );

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
    ];

    return (
        <div
            data-component-name="QuillTextEditor"
            className={classNames(
                "w-full appearance-none overflow-hidden outline-0",
                themeConfig.transition,
                rounded,
                className
            )}
            {...rest}
        >
            <style>
                {`
        .ql-container {
          border-bottom-left-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
          font-size: 16px;
          font-family: 'Roboto', sans-serif;
          min-height: 120px;
        }
        .ql-toolbar {
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
        }
        `}
            </style>
            <ReactQuill
                id={id}
                theme="snow"
                value={value || ""}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
            />
        </div>
    );
};

export default QuillTextEditor;
